import { ReduxAction, ReduxDispatch } from '../../../Configs/Redux/Types';
import { ICourseInstance } from '../../../__core/Interfaces/ICourseInstance';
import { AppState } from '../../../Configs/Redux/AppState';
import { get } from 'lodash';
import { bindActionCreators } from 'redux';
import { fetchCoursesList, fetchProductsList } from '../Actions/Actions';
import { connect } from 'react-redux';
import CoursesList from '../Components/CoursesList';
import { IProduct } from '../../../__core/Interfaces/IProduct';
import REDIRECT_TYPES from '../../../__core/Enums/RedirectTypes';

export type DispatchToPropsForCoursesListContainer = {
  actions: {
    fetchCoursesList: (
      values: Record<string, unknown> | null
    ) => ReduxAction<Promise<unknown>>;
    fetchProductsList: () => ReduxAction<Promise<unknown>>;
  };
};

export type StateToPropsForCoursesListContainer = {
  isLoading: boolean;
  courses: Array<ICourseInstance>;
  products: Array<IProduct>;
  coursesListCurrentPage: number;
  coursesListPages: number;
  userId: number;
  userRoles: Array<string>;
  userRedirect: {
    payload: unknown | null;
    type: REDIRECT_TYPES | null;
  };
};

const mapStateToProps = (
  store: AppState
): StateToPropsForCoursesListContainer => {
  const {
    ajaxCallInProgressCount,
    App: {
      user: { id: userId, roles: userRoles, redirect },
    },
    Courses: {
      coursesList: { data: coursesListItems, metadata: coursesListMetadata },
      productList,
    },
  } = store;

  return {
    isLoading: ajaxCallInProgressCount > 0,
    coursesListCurrentPage: get(coursesListMetadata, 'currentPage') as number,
    coursesListPages: get(coursesListMetadata, 'pages') as number,
    courses: coursesListItems,
    products: productList,
    userId,
    userRoles,
    userRedirect: redirect,
  };
};

const mapDispatchToProps = (
  dispatch: ReduxDispatch
): DispatchToPropsForCoursesListContainer => ({
  actions: bindActionCreators(
    { fetchCoursesList, fetchProductsList },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CoursesList);
